// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var TabsBinding = (function () {
    function TabsBinding() {
        var _this = this;
        this.bindings = {};
        this.getElementBinding = function (elementId) {
            return {
                elementId: elementId,
                document: document.getElementById(elementId),
                binding: _this.bindings[elementId]
            };
        };
        this.elementFound = function (elementBinding) {
            var elementFound = typeof (elementBinding.document) !== "undefined" && elementBinding.document != null;
            if (!elementFound) {
                console.error("The element with the ID '" + elementBinding.elementId + "' was not found. Ensure the element exists in the DOM.");
            }
            return elementFound;
        };
        this.initBinding = function (itemId) {
            if (!_this.bindings.hasOwnProperty(itemId)) {
                _this.bindings[itemId] = {
                    tabNot: []
                };
            }
            return _this.bindings[itemId];
        };
        this.applyBinding = function (elementBinding) {
            _this.addExcludeFromTabTag(elementBinding.document, elementBinding.binding.tabNot);
        };
        this.addExcludeFromTabTag = function (element, bindings) {
            if (bindings.length > 0) {
                element.setAttribute("data-tab-not", bindings.join(","));
            }
        };
    }
    TabsBinding.prototype.excludeItemsIdsInTab = function (elementIds, tabId) {
        elementIds.map(this.initBinding, this).forEach(function (binding) {
            binding.tabNot.push(tabId);
        });
    };
    TabsBinding.prototype.applyBindings = function () {
        Object.keys(this.bindings)
            .map(this.getElementBinding)
            .filter(this.elementFound)
            .forEach(this.applyBinding);
    };
    return TabsBinding;
}());
exports.__esModule = true;
exports["default"] = TabsBinding;



//////////////////
// WEBPACK FOOTER
// ./Base/Tabs/TabsBinding.ts
// module id = 17
// module chunks = 0